import * as React from "react";
import type { SVGProps } from "react";
const SvgCityViewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M16.4 3c.592 0 1.071.48 1.071 1.071v4.937Q17.535 9 17.6 9h5.8c.592 0 1.071.48 1.071 1.071v12.4h-.942v-12.4a.13.13 0 0 0-.129-.128h-5.8a.13.13 0 0 0-.129.128v12.4h-.942v-18.4a.13.13 0 0 0-.129-.128H4.6a.13.13 0 0 0-.129.128v18.4H3.53v-18.4C3.529 3.48 4.009 3 4.6 3zM1 23.471h26.571v.857H1z"
    />
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M19.5 11.471a.5.5 0 0 0-.5.5v2.2a.5.5 0 0 0 .5.5h2.2a.5.5 0 0 0 .5-.5v-2.2a.5.5 0 0 0-.5-.5zm1.83.88h-1.45v1.45h1.45zM19 16.971a.5.5 0 0 1 .5-.5h2.2a.5.5 0 0 1 .5.5v2.2a.5.5 0 0 1-.5.5h-2.2a.5.5 0 0 1-.5-.5zm.88.38h1.45v1.45h-1.45zM6.9 5.471a.5.5 0 0 0-.5.5v2.2a.5.5 0 0 0 .5.5h2.2a.5.5 0 0 0 .5-.5v-2.2a.5.5 0 0 0-.5-.5zm1.83.88H7.28v1.45h1.45zM6.4 9.971a.5.5 0 0 1 .5-.5h2.2a.5.5 0 0 1 .5.5v2.2a.5.5 0 0 1-.5.5H6.9a.5.5 0 0 1-.5-.5zm.88.38h1.45v1.45H7.28zM6.9 13.471a.5.5 0 0 0-.5.5v2.2a.5.5 0 0 0 .5.5h2.2a.5.5 0 0 0 .5-.5v-2.2a.5.5 0 0 0-.5-.5zm1.83.88H7.28v1.45h1.45zM6.4 17.971a.5.5 0 0 1 .5-.5h2.2a.5.5 0 0 1 .5.5v2.2a.5.5 0 0 1-.5.5H6.9a.5.5 0 0 1-.5-.5zm.88.38h1.45v1.45H7.28zM11.9 5.471a.5.5 0 0 0-.5.5v2.2a.5.5 0 0 0 .5.5h2.2a.5.5 0 0 0 .5-.5v-2.2a.5.5 0 0 0-.5-.5zm1.83.88h-1.45v1.45h1.45zM11.4 9.971a.5.5 0 0 1 .5-.5h2.2a.5.5 0 0 1 .5.5v2.2a.5.5 0 0 1-.5.5h-2.2a.5.5 0 0 1-.5-.5zm.88.38h1.45v1.45h-1.45zM11.9 13.471a.5.5 0 0 0-.5.5v2.2a.5.5 0 0 0 .5.5h2.2a.5.5 0 0 0 .5-.5v-2.2a.5.5 0 0 0-.5-.5zm1.83.88h-1.45v1.45h1.45zM11.4 17.971a.5.5 0 0 1 .5-.5h2.2a.5.5 0 0 1 .5.5v2.2a.5.5 0 0 1-.5.5h-2.2a.5.5 0 0 1-.5-.5zm.88.38h1.45v1.45h-1.45z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCityViewIcon;
